import { render, staticRenderFns } from "./AdressSummary.vue?vue&type=template&id=163075f9"
import script from "./AdressSummary.vue?vue&type=script&lang=js"
export * from "./AdressSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports